module.exports = __webpack_public_path__ + "img/BHS.3ce6ab64.svg";